/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Serve_RemoveInputs */

const en_serve_remove = /** @type {(inputs: Serve_RemoveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Remove this computer`)
};

const id_serve_remove = /** @type {(inputs: Serve_RemoveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hapus komputer ini`)
};

/**
* | output |
* | --- |
* | "Remove this computer" |
*
* @param {Serve_RemoveInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const serve_remove = /** @type {((inputs?: Serve_RemoveInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Serve_RemoveInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_serve_remove(inputs)
	return en_serve_remove(inputs)
});